export default {
  //* addQuote ---------------------------------------------------------------------------------------------------------------

  addQuote(context, data) {
    context.commit("addQuote", data);
  },
};
